var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'theme_' + _vm.theme,style:({
  '--font': _vm.isApple
    ? "'Myriad', 'Bogle', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'"
    : 'Myriad',
  '--btnColor': '#0097b2',
  '--nav-background': 'linear-gradient(180deg, #0690A9 0%, #44515A 100%)',
  '--newbtnColor': '#ae8f3d',
  '--bgImg': ("url(" + (_vm.$img('/bg1.png')) + ")"),
  '--userBg': ("url(" + (_vm.$img('/bg1.png')) + ")")
  // '--bgImg': `url(${bgImage})`,
  // '--userBg': `url(${bgImage})`
}),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }